var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { ProjectCategory } from '@/models/ProjectCategory';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';
let CreateOrEditProjectCategoryDialog = class CreateOrEditProjectCategoryDialog extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.category = null;
        this.isLoading = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeCategory();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onSubmit() {
        if (!this.category) {
            return;
        }
        const payload = {
            name: this.category.name,
        };
        if (this.isEditing) {
            this.onUpdateCategory(payload);
        }
        else {
            this.onCreateCategory(payload);
        }
    }
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.category = new ProjectCategory();
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateCategory(payload) {
        try {
            await this.existingCategory.update(payload);
            this.$emit('subjectLabelCategoryUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateCategory(payload) {
        try {
            await new ProjectCategory().create(payload);
            this.$emit('subjectLabelCategoryCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeCategory() {
        if (this.existingCategory) {
            this.category = this.existingCategory;
        }
        else {
            this.category = new ProjectCategory();
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        return this.category === null || (!!this.category.name && this.category.name.trim() === '');
    }
    get isEditing() {
        return !!this.existingCategory;
    }
    get title() {
        return this.isEditing ? this.$tc('Edit goal set category') : this.$tc('Add goal set category');
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof ProjectCategory !== "undefined" && ProjectCategory) === "function" ? _a : Object)
], CreateOrEditProjectCategoryDialog.prototype, "existingCategory", void 0);
CreateOrEditProjectCategoryDialog = __decorate([
    Component({})
], CreateOrEditProjectCategoryDialog);
export default CreateOrEditProjectCategoryDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
